import { FormTitle } from '@molecules/*';
import { Button } from '@atoms/*';
import { REPORT_IT_WEBSITE_LINK, RETURN_TO_HOME_PAGE_TEXT } from '@constants';

export const ReportToPrivateOwner = () => {
  const title = 'Report to the private property owner';
  const navigationButton = {
    label: RETURN_TO_HOME_PAGE_TEXT,
    href: REPORT_IT_WEBSITE_LINK,
  };
  return (
    <>
      <FormTitle text={title} />
      <div className="text-bodyLg my-4 flex flex-col gap-4">
        <p>
          We do not deal with drain issues on private property. Report the issue
          to the property owner as they are responsible for fixing it.
        </p>
      </div>
      <section data-testid="navigate-to-homepage" className="mt-20">
        <Button
          id="navigation-button"
          variant="primary"
          color="navigation-primary"
          label={navigationButton.label}
          isExternalLink={true}
          openInNewTab={true}
          href={navigationButton.href}
        />
      </section>
    </>
  );
};
